module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_3_m.4a5d28bcf9ff076760be69f08efdf4a8.png";